import React, { useEffect, useState } from 'react';
import './SipPage.css';
import PageLayout from '../Components/PageLayout';

const faqs = [
  {
    question: 'What is a gold SIP and how does it work on CoinBazaar powered by eBullion?',
    answer:
      "A gold SIP (Systematic Investment Plan) on CoinBazaar powered by eBullion allows you to invest a fixed amount — starting from ₹100 — weekly or monthly in 24K digital gold. Your investment buys real gold at the day's market price, which is stored securely in your name.",
  },
  {
    question: 'What is the CoinBazaar powered by eBullion Daily SIP Plan?',
    answer:
      'The Daily SIP Plan lets you invest as little as ₹10 per day in digital gold, digital silver, digital platinum and digital palladium. It works like a SIP but with daily UPI auto-debits, allowing consistent wealth creation with minimal effort.',
  },
  {
    question: 'How do I start a SIP or Daily SIP Plan on CoinBazaar powered by eBullion?',
    answer:
      'Just log in, complete KYC, choose your plan, set your investment amount and frequency, and authorize an eMandate for auto-debit.',
  },
  {
    question: 'What is the minimum amount to start a gold SIP?',
    answer:
      'You can start a gold SIP on CoinBazaar powered by eBullion with just ₹100 per week or per month.',
  },
  {
    question: 'Can I invest ₹10 per day in gold through CoinBazaar powered by eBullion?',
    answer:
      'Yes, the Daily SIP Plan allows you to invest as little as ₹10/day in digital gold or silver.',
  },
  {
    question: 'Is the gold I buy through SIP backed by physical gold?',
    answer:
      'Yes, every SIP investment is 100% backed by physical 24K gold stored with SEBI-regulated and insured vaulting partners.',
  },
  {
    question: 'Is there a lock-in period in CoinBazaar powered by eBullion SIP or Daily SIP Plan?',
    answer:
      'No, there is no lock-in period. You can pause, stop, or redeem your investment anytime.',
  },
  {
    question: 'Can I invest in silver, platinum, or palladium SIPs?',
    answer:
      'Yes, CoinBazaar powered by eBullion allows you to start SIPs in silver, platinum, and palladium along with gold.',
  },
  {
    question: 'How is the purchase price determined in SIP and Daily Plan?',
    answer:
      'For both plans, your purchase price is based on the live market rate at 10 AM IST on the day of investment.',
  },
  {
    question: 'How do I redeem my SIP or Daily SIP investment?',
    answer:
      'You can redeem your holdings any time on the platform — either as cash credited to your bank or as physical metal (gold/silver coins or bars).',
  },
  {
    question: 'Is my gold safe on CoinBazaar powered by eBullion?',
    answer:
      'Yes, your metal is securely stored in your name, fully insured, and sourced from Hindustan Platinum Pvt Ltd, an accredited refiner.',
  },
  {
    question: 'Can I take physical delivery of my accumulated gold or silver?',
    answer:
      'Yes, you can opt for delivery of your accumulated gold or silver in tamper-proof, certified packaging.',
  },
  {
    question: 'Can I modify my SIP amount or frequency later?',
    answer:
      'Yes, you can change your SIP amount, frequency, or even stop it anytime without any penalty or fee.',
  },
  {
    question: 'Is SIP in gold better than buying gold one-time?',
    answer:
      'SIP allows you to average out the price over time (rupee-cost averaging), making it a better long-term strategy compared to timing the market.',
  },
  {
    question: 'Which is better – Daily Gold Saving Plan or Monthly SIP?',
    answer:
      'Both serve different needs: Daily Plans are ideal for micro-savers, while SIPs work better for structured long-term investing. Many users combine both for maximum benefit.',
  },
  {
    question: 'Are there any charges or hidden fees on SIP or Daily Plan?',
    answer:
      'There are no hidden charges. All applicable taxes and charges are transparently displayed at the time of purchase.',
  },
  {
    question: 'Can I start multiple SIPs on CoinBazaar powered by eBullion?',
    answer:
      'Yes, you can start and manage multiple SIPs for different metals or different goals from the same dashboard.',
  },
  {
    question: 'What happens if I miss an instalment in Daily Plan or SIP?',
    answer:
      'There is no penalty. If a payment fails, your SIP will skip that cycle and resume in the next one as scheduled.',
  },
  {
    question: 'Can I pause or stop my SIP or Daily Plan anytime?',
    answer:
      'Absolutely. CoinBazaar powered by eBullion gives you full flexibility — you can pause, cancel, or restart your plan whenever you want.',
  },
];

const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="sip-faq-list">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`sip-faq-item${openIndex === index ? ' sip-faq-item--open' : ''}`}
        >
          <button
            className="sip-faq-question"
            onClick={() => toggle(index)}
            aria-expanded={openIndex === index}
          >
            <span className="sip-faq-num">{index + 1}.</span>
            <span className="sip-faq-qtext">{faq.question}</span>
            <span className="sip-faq-icon">{openIndex === index ? '−' : '+'}</span>
          </button>
          {openIndex === index && (
            <div className="sip-faq-answer">{faq.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
};

const SipPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageLayout page="sip">
      <div className="sip-wrapper">
        <div className="sip-container">

          {/* ── Page Header ── */}
          <div className="sip-page-header">
            <span className="sip-eyebrow">Digital Precious Metals</span>
            <h1 className="sip-page-title">
              CoinBazaar powered by eBullion Digital Precious Metal Investment Plans
            </h1>
            <p className="sip-page-subtitle">
              Simple, transparent, and accessible investing in precious metals — for every budget and lifestyle.
            </p>
          </div>

          {/* ── Intro ── */}
          <div className="sip-section">
            <p className="sip-p">
              At CoinBazaar powered by eBullion, we make investing in precious metals simple, transparent, and
              accessible for all. Whether you prefer investing every month, every week, or every single day — we
              have a plan that fits your lifestyle and budget.
            </p>
            <p className="sip-p">
              Our Systematic Investment Plan (SIP) and Daily SIP Plan empower you to gradually build your wealth
              in pure gold (9999), silver (9999), platinum (999.5), and palladium (999.5) — backed by global
              standards and full transparency.
            </p>
          </div>

          {/* ── Section: What is SIP ── */}
          <div className="sip-section">
            <h2 className="sip-h2">What Is a Digital Precious Metal SIP?</h2>
            <p className="sip-p">
              A Systematic Investment Plan (SIP) on CoinBazaar powered by eBullion allows you to invest a fixed
              amount in gold, silver, platinum, or palladium at regular intervals — monthly or weekly. SIPs help
              you accumulate real precious metals over time, without worrying about market timing.
            </p>

            <h3 className="sip-h3">Key Features of Digital Metals SIP</h3>
            <ul className="sip-list">
              <li>Choose between Daily SIP, Monthly or Weekly</li>
              <li>Start from just ₹10/day or ₹100/week/month</li>
              <li>Choose from Digital Gold, Silver, Platinum or Palladium</li>
              <li>No lock-in — stop or pause anytime</li>
              <li>Fully backed by physical bullion stored securely in 3rd party vaults</li>
              <li>Prices derived from global spot markets</li>
              <li>Redeem anytime as cash or physical metal (coming soon)</li>
              <li>Live portfolio dashboard with insights</li>
            </ul>
          </div>

          {/* ── Section: Daily SIP ── */}
          <div className="sip-section">
            <h2 className="sip-h2">Daily SIP Plan — Save as Little as ₹10/Day</h2>
            <p className="sip-p">
              Designed for micro-savers and first-time investors, the Daily SIP Plan is the easiest way to
              accumulate gold or silver. It works just like SIP — but with daily auto-debits starting at only
              ₹10/day.
            </p>

            <h3 className="sip-h3">Daily SIP Highlights</h3>
            <ul className="sip-list">
              <li>Minimum investment: ₹10/day</li>
              <li>Buy digital gold or silver in micro-amounts</li>
              <li>Auto-debit via eMandate — no manual effort</li>
              <li>Metal bought at daily 10 AM rate</li>
              <li>100% secure, insured &amp; verified holdings</li>
              <li>Withdraw as cash or physical delivery</li>
              <li>Track your savings gram-by-gram, day-by-day</li>
            </ul>

            <h3 className="sip-h3">Who Should Opt for Daily SIP Plan?</h3>
            <div className="sip-usecases">
              <div className="sip-usecase">
                <span className="sip-usecase-num">1</span>
                <div>
                  <strong>Students &amp; First-Time Investors</strong>
                  <p>No pressure of large investment, builds habit early.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">2</span>
                <div>
                  <strong>Young Professionals &amp; Salaried Employees</strong>
                  <p>Manageable daily saving builds backup effortlessly.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">3</span>
                <div>
                  <strong>Parents Saving for Their Children</strong>
                  <p>Safe and stable asset for long-term gifting or education.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">4</span>
                <div>
                  <strong>Homemakers &amp; Non-Salaried Individuals</strong>
                  <p>Flexible, low-commitment, ideal for informal income earners.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">5</span>
                <div>
                  <strong>Micro-Investors &amp; Habit-Builders</strong>
                  <p>Turns daily spending into disciplined investing.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">6</span>
                <div>
                  <strong>Senior Citizens or Retirees</strong>
                  <p>Safe, easy-to-monitor savings without risk exposure.</p>
                </div>
              </div>
            </div>

            <h3 className="sip-h3">Daily SIP Plan Is For You If You:</h3>
            <ul className="sip-checklist">
              <li>Want to start with just ₹10/day</li>
              <li>Prefer a "little every day" approach to wealth building</li>
              <li>Want flexibility without lock-ins</li>
              <li>Are new to investing but serious about long-term growth</li>
              <li>Believe in accumulating real, inflation-hedged assets</li>
            </ul>
          </div>

          {/* ── Section: Weekly / Monthly SIP ── */}
          <div className="sip-section">
            <h2 className="sip-h2">Who Should Opt for Weekly or Monthly SIP?</h2>
            <p className="sip-p">
              Designed for goal-based investors, SIPs suit people who think ahead and want long-term portfolio
              diversification with real assets.
            </p>
            <div className="sip-usecases">
              <div className="sip-usecase">
                <span className="sip-usecase-num">1</span>
                <div>
                  <strong>Salaried Professionals &amp; Working Individuals</strong>
                  <p>Syncs with pay cycles, fully automated investing.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">2</span>
                <div>
                  <strong>Families Planning for Future Goals</strong>
                  <p>Accumulate assets for education, weddings, or legacy.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">3</span>
                <div>
                  <strong>Investors Seeking Portfolio Diversification</strong>
                  <p>Non-correlated to markets, hedges inflation risks.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">4</span>
                <div>
                  <strong>Business Owners &amp; Entrepreneurs</strong>
                  <p>Diversify profits into stable, real assets.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">5</span>
                <div>
                  <strong>Retirement Planners &amp; Conservative Investors</strong>
                  <p>Safe, real asset class with easy redemption options.</p>
                </div>
              </div>
              <div className="sip-usecase">
                <span className="sip-usecase-num">6</span>
                <div>
                  <strong>Individuals Saving for Physical Gold Delivery</strong>
                  <p>Perfect for redeeming as coins or bars later.</p>
                </div>
              </div>
            </div>
          </div>

          {/* ── Conclusion ── */}
          <div className="sip-section">
            <h2 className="sip-h2">Build Real Wealth, One Step at a Time</h2>
            <p className="sip-p">
              Whether you're starting with ₹10/day or ₹100/week, CoinBazaar powered by eBullion makes it simple,
              secure, and smart to invest in digital gold, silver, platinum, and palladium — backed by real
              physical bullion.
            </p>
            <p className="sip-p">Choose the plan that fits your life:</p>
            <div className="sip-plan-summary">
              <div className="sip-plan-card">
                <strong>Daily SIP Plan</strong>
                <span>For habit-formers, first-time investors, and micro-savers</span>
              </div>
              <div className="sip-plan-card">
                <strong>Weekly / Monthly SIP</strong>
                <span>For structured investors, goal planners, and portfolio diversifiers</span>
              </div>
            </div>
            <p className="sip-p sip-closing">
              Start small. Stay consistent. Grow smart. Own real wealth in the world's most trusted assets — gold
              and silver. Start your journey with CoinBazaar powered by eBullion today.
            </p>
          </div>

          {/* ── FAQ ── */}
          <div className="sip-section">
            <h2 className="sip-h2">Frequently Asked Questions</h2>
            <FaqAccordion />
          </div>

        </div>
      </div>
    </PageLayout>
  );
};

export default SipPage;